import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import storageUtils from "../utils/storageUtils"; // 确保路径正确

export default function HanderComponen() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // 从 URL 查询参数中获取 user_token
    const token = searchParams.get("user_token");
    if (token) {
      storageUtils.set("user_token", token); // 保存 token
    }
  }, [searchParams]);

}